import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import App from './App';
import { PublicRoutes } from './pages/PublicRoutes';

const AppWrapper = () => {
    let location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const auth = sessionStorage.getItem('auth') !== undefined ? sessionStorage.getItem('auth') : null;

    return (
       auth !== null ? <App></App > : <PublicRoutes></PublicRoutes>
    );
};

export default AppWrapper;
